<template>
  <div class="supplier-basic app-container">
    <div class="page-header">
      <div class="page-header__left">
        <h2 class="page-header__title">基本资料</h2>
        <p class="page-header__desc">查看与维护本账号供应商基础信息及开票资料</p>
      </div>
      <div class="page-header__actions">
        <el-button
          v-if="homeState == 0"
          type="primary"
          size="small"
          plain
          icon="el-icon-refresh"
          @click="getList()"
        >
          刷新
        </el-button>
        <el-button
          v-if="homeState == 0"
          type="primary"
          size="small"
          icon="el-icon-edit"
          @click="updateClick()"
        >
          修改
        </el-button>
        <el-button
          v-if="homeState == 1"
          type="primary"
          size="small"
          icon="el-icon-check"
          @click="saveClick()"
        >
          提交审核
        </el-button>
        <el-button
          v-if="homeState == 1"
          size="small"
          plain
          @click="closeClick()"
        >
          取消
        </el-button>
      </div>
    </div>

    <!-- 查看 -->
    <div v-if="homeState == 0" class="page-body">
      <div class="info-panel">
        <div class="section-title">丨基础资料</div>
        <el-descriptions
          class="info-desc"
          size="small"
          :column="3"
          border
          :label-style="labelStyle"
          :content-style="contentStyle"
        >
          <el-descriptions-item label="公司名称">
            {{ display(singleData.baseSupplierName) }}
          </el-descriptions-item>
          <el-descriptions-item label="主营品牌">
            {{ display(singleData.baseMainBrand) }}
          </el-descriptions-item>
          <el-descriptions-item label="法定代表人">
            {{ display(singleData.baseSupplierCorporate) }}
          </el-descriptions-item>
          <el-descriptions-item label="联系人">
            {{ display(singleData.baseSupplierContactsName) }}
          </el-descriptions-item>
          <el-descriptions-item label="联系方式">
            {{ display(singleData.baseSupplierPhone) }}
          </el-descriptions-item>
          <el-descriptions-item label="联系地址">
            {{ display(singleData.baseSupplierAddress) }}
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div class="info-panel">
        <div class="section-title">丨开票信息</div>
        <el-descriptions
          class="info-desc"
          size="small"
          :column="2"
          border
          :label-style="labelStyle"
          :content-style="contentStyle"
        >
          <el-descriptions-item label="公司名称">
            {{ display(singleData.invoicedefaultCompanyName) }}
          </el-descriptions-item>
          <el-descriptions-item label="信用代码">
            {{ display(singleData.invoicedefaultUnifiedCode) }}
          </el-descriptions-item>
          <el-descriptions-item label="地址、电话" :span="2">
            {{ display(singleData.invoicedefaultAddress) }}
          </el-descriptions-item>
          <el-descriptions-item label="银行账号">
            {{ display(singleData.invoicedefaultBankAccount) }}
          </el-descriptions-item>
          <el-descriptions-item label="开户行">
            {{ display(singleData.invoicedefaultBank) }}
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div class="info-panel info-panel--table">
        <div class="section-title">丨变更记录</div>
        <myHtml
          :maxHeight="this.$root.tableHeight - 50"
          :id="'bill_one'"
          :columnType="'columnIndex'"
          :list="list"
          :titleList="titleList"
          :tableBtnList="['取消']"
          @btnClick="btnClick"
          ref="myTable"
        />
      </div>
    </div>

    <!-- 修改 -->
    <div v-if="homeState == 1" class="page-body">
      <div class="info-panel">
        <div class="section-title">丨基础资料</div>
        <el-descriptions
          class="info-desc info-desc--edit"
          size="small"
          :column="3"
          border
          :label-style="labelStyle"
          :content-style="contentStyle"
        >
          <el-descriptions-item label="公司名称">
            <el-input
              v-model="updateData.baseSupplierName"
              size="small"
              placeholder="请输入公司名称"
            />
          </el-descriptions-item>
          <el-descriptions-item label="主营品牌">
            <el-input
              v-model="updateData.baseMainBrand"
              size="small"
              placeholder="请输入主营品牌"
            />
          </el-descriptions-item>
          <el-descriptions-item label="法定代表人">
            <el-input
              v-model="updateData.baseSupplierCorporate"
              size="small"
              placeholder="请输入法定代表人"
            />
          </el-descriptions-item>
          <el-descriptions-item label="联系人">
            <el-input
              v-model="updateData.baseSupplierContactsName"
              size="small"
              placeholder="请输入联系人"
            />
          </el-descriptions-item>
          <el-descriptions-item label="联系方式">
            <el-input
              v-model="updateData.baseSupplierPhone"
              size="small"
              placeholder="请输入联系方式"
            />
          </el-descriptions-item>
          <el-descriptions-item label="联系地址">
            <el-input
              v-model="updateData.baseSupplierAddress"
              size="small"
              placeholder="请输入联系地址"
            />
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div class="info-panel">
        <div class="section-title">丨开票信息</div>
        <el-descriptions
          class="info-desc info-desc--edit"
          size="small"
          :column="2"
          border
          :label-style="labelStyle"
          :content-style="contentStyle"
        >
          <el-descriptions-item label="公司名称">
            <el-input
              v-model="updateData.invoicedefaultCompanyName"
              size="small"
              placeholder="请输入开票公司名称"
            />
          </el-descriptions-item>
          <el-descriptions-item label="信用代码">
            <el-input
              v-model="updateData.invoicedefaultUnifiedCode"
              size="small"
              placeholder="请输入信用代码"
            />
          </el-descriptions-item>
          <el-descriptions-item label="地址、电话" :span="2">
            <el-input
              v-model="updateData.invoicedefaultAddress"
              size="small"
              placeholder="请输入地址、电话"
            />
          </el-descriptions-item>
          <el-descriptions-item label="银行账号">
            <el-input
              v-model="updateData.invoicedefaultBankAccount"
              size="small"
              placeholder="请输入银行账号"
            />
          </el-descriptions-item>
          <el-descriptions-item label="开户行">
            <el-input
              v-model="updateData.invoicedefaultBank"
              size="small"
              placeholder="请输入开户行"
            />
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
  </div>
</template>

<script>
import {
  supplier_view,
  pmgtCooperateDraftDoc_list,
  pmgtCooperateDraftDoc_add,
  pmgtCooperateDraftDoc_delete,
} from "@/api/myController/purchase";
import { getCurrentTime } from "@/utils/myUtils";
export default {
  name: "supplier_basic",
  data() {
    return {
      labelStyle: {
        width: "110px",
        height: "44px",
        lineHeight: "28px",
        padding: "8px 12px",
        textAlign: "center",
        fontWeight: "600",
        color: "#606266",
        background: "#fafafa",
        wordBreak: "keep-all",
        verticalAlign: "middle",
      },
      contentStyle: {
        minWidth: "160px",
        height: "44px",
        lineHeight: "28px",
        padding: "8px 12px",
        verticalAlign: "middle",
      },
      updateData: {},
      singleData: {},
      homeState: 0,
      list: [],
      titleList: [
        {
          id: 11,
          name: "标题",
          value: "cooperateDraftTitle",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,
        },
        {
          id: 11,
          name: "修改类型",
          value: "checkType",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,
        },
        {
          id: 9,
          name: "执行状态",
          value: "statusExecution",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionKey: "",
          selectOptionList: [
            {
              label: "已执行",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未执行",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: true,
        },
        {
          id: 9,
          name: "审核状态",
          value: "statusCheck",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionKey: "",
          selectOptionList: [
            {
              label: "已审核",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未审核",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: true,
        },
        {
          id: 11,
          name: "创建时间",
          value: "createTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: true,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    display(value) {
      if (value === undefined || value === null || value === "") return "--";
      return value;
    },
    getList() {
      supplier_view({ supplierId: this.getUserInfo.supplierId }).then((res) => {
        this.singleData = res.data.data;
      });
      pmgtCooperateDraftDoc_list({
        pmgtCooperateDraftDocDtoFilter: {
          checkType: "基本信息",
        },
      }).then((res) => {
        this.list = res.data.data.dataList;
      });
    },
    async btnClick(row, item) {
      switch (item) {
        case "取消":
          if (row.statusCheck == 0) {
            this.$confirm("确定取消？, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                pmgtCooperateDraftDoc_delete({
                  cooperateDraftDocId: row.cooperateDraftDocId,
                }).then(() => {
                  this.$message.success("操作成功！");
                  this.getList();
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          } else {
            this.$message({
              type: "info",
              message: "已审核状态不能进行取消！",
            });
          }
          break;
        default:
          break;
      }
    },
    updateClick() {
      this.updateData = JSON.parse(JSON.stringify(this.singleData));
      this.homeState = 1;
    },
    saveClick() {
      let json = {
        cooperateDraftTitle: "基本信息修改-" + getCurrentTime(),
        checkType: "基本信息",
        cooperateDraftDataDomain: JSON.stringify(this.updateData),
        supplierId: this.getUserInfo.supplierId,
        presenterId: this.getUserInfo.supplierId,
        presenterName: this.getUserInfo.showName,
        supplierName: this.getUserInfo.showName,
        supplierNumber: this.getUserInfo.supplierNumber,
        statusExecution: 0,
        statusCheck: 0,
        scheduleDocTime: getCurrentTime(),
      };
      pmgtCooperateDraftDoc_add({ pmgtCooperateDraftDocDto: json }).then(() => {
        this.$message.success("操作成功！");
        this.getList();
        this.homeState = 0;
      });
    },
    closeClick() {
      this.homeState = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.supplier-basic {
  min-height: calc(100vh - 120px);
  padding-bottom: 24px;
  background: #fff;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #ebeef5;
}

.page-header__title {
  margin: 0;
  color: #1476c3;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
}

.page-header__desc {
  margin: 6px 0 0;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.page-header__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.page-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-panel {
  padding: 16px 18px 18px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.info-panel--table {
  padding-bottom: 10px;
}

.section-title {
  margin: 0 0 12px;
  color: #1476c3;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.4;
}

.info-desc {
  margin-bottom: 0;
}

.info-desc ::v-deep .el-descriptions-item__cell {
  height: 44px;
  padding: 8px 12px;
  vertical-align: middle;
}

.info-desc--edit ::v-deep .el-descriptions-item__cell {
  height: 52px;
  padding: 10px 12px;
}

.info-desc--edit ::v-deep .el-input {
  width: 100%;
}

.info-desc--edit ::v-deep .el-input__inner {
  height: 32px;
  line-height: 32px;
}

::v-deep .el-descriptions-item__label.is-bordered-label {
  color: #606266;
  font-weight: 600;
  background: #fafafa;
}

::v-deep .el-descriptions-item__content {
  color: #303133;
}
</style>
